import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExtractPropertyPipe } from './extract-property.pipe';




@NgModule({
  declarations: [
    ExtractPropertyPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [ExtractPropertyPipe]
})
export class PipesModule { }
